import React, { useState, useEffect } from "react";
import ContactForm from "../containers/Contact/ContactForm";

const Contact: React.FC = () => {
    return <ContactForm />;
};

export default Contact;
